// extracted by mini-css-extract-plugin
export default {"authorPageMain":"AuthorPage_authorPageMain__N5Vwx","customLoader":"AuthorPage_customLoader__sJrKi","spinner":"AuthorPage_spinner__N+VTC"};